export const resetPasswordSteps = [
    {
        step: 1,
        title: 'reset-password.step-1-title',
        text: 'reset-password.step-1-text',
        titleFr: 'reset-password.step-1-title-fr',
        textFr: 'reset-password.step-1-text-fr'
    },
    {
        step: 2,
        title: 'reset-password.step-2-title',
        text: 'reset-password.step-2-text',
        titleFr: 'reset-password.step-2-title-fr',
        textFr: 'reset-password.step-2-text-fr'
    },
    {
        step: 3,
        title: 'reset-password.step-3-title',
        text: 'reset-password.step-3-text',
        titleFr: 'reset-password.step-3-title-fr',
        textFr: 'reset-password.step-3-text-fr'
    },
    {
        step: 4,
        title: 'reset-password.step-4-title',
        text: 'reset-password.step-4-text',
        titleFr: 'reset-password.step-4-title-fr',
        textFr: 'reset-password.step-4-text-fr'
    }
];
